import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField } from '../../../../Formik'
import { USER_FORM_FIELD_NAME_ROLE, UserRoleSelect } from '../../../../User'

import * as styles from './RoleField.module.css'

function RoleField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Select={UserRoleSelect}
      className={styles.roleFieldSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        indicatorsProps: {
          ButtonClear: null,
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        label: `${t('Inhabitant.RoleLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      name={USER_FORM_FIELD_NAME_ROLE}
    />
  )
}

export default RoleField
